// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import useRouter from '../../../hooks/useRouter';
import RoutesRedirectionFactory from '../../../utils/routes/RoutesRedirectionFactory';
import GRRulesButton from '../components/common/GRRulesButton';
import useRoundContext from '../hooks/useGRRoundContext';
import selectGRRulesButtonProps from '../selectors/specifics/selectGRRulesButtonProps';
import { ObfGRRounds } from '../types/round';

type GRRulesButtonContainerProps = {
  className?: string;
};

const GRRulesButtonContainer = ({ ...ownProps }: GRRulesButtonContainerProps) => {
  const { history } = useRouter();
  const selectedProps = useSelector(selectGRRulesButtonProps);
  const { roundId } = useRoundContext();

  const onClick = useCallback(() => {
    history.push(RoutesRedirectionFactory.getGRRoundRulesRouteConfig(ObfGRRounds[roundId]));
  }, [roundId, history]);

  const otherProps = useMemo(() => ({ onClick }), [onClick]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <GRRulesButton {...enhancedProps} />;
};

export default GRRulesButtonContainer;
